import React from 'react';
import styled from 'styled-components';
import SwitchiOS from '../../../SwitchiOS';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import {
  IBuilder,
  toggleBreakdownOverall,
} from '../../../../redux/slices/oldBuilder';
import KubitTooltip from '../../../KubitTooltip';
import { breakdownOverallTooltipOption } from '../../../KubitTooltip/globalTooltips';
import * as BuilderUI from '../../BuilderUI';
import { theme } from '../../../../styles/theme';

const Label = styled(BuilderUI.BuilderFieldLabel)<{ $isActive: boolean }>`
  ${({ $isActive }) =>
    $isActive &&
    `
    color: ${theme.colors.mainBlue};
  `};
`;

/**
 * KBT-817: we force breakdown overall for the cases:
 * 1. measure has forceBreakdownOverall flag;
 * 2. measure formula has division operation.
 * But for the old reports, we still show the negative on overall in formula page
 * to keep the correctness of the formual, but after re-execute, it will be set to true.
 * this is also mentioned in the formula page - overall tootlips.
 * @param builderState
 * @returns
 */
export const checkIsForceBreakdownOverall = (builderState: IBuilder) => {
  const { measures, measureFormula } = builderState;
  return (
    measures.some((measure) => measure.fn.forceBreakdownOverall) ||
    (measureFormula?.isValid && measureFormula.expression?.includes('/'))
  );
};

const BreakdownOverall = () => {
  const dispatch = useAppDispatch();
  const overallBreakdown = useAppSelector(
    ({ builder }) => builder.breakdown.overall,
  );

  const isForceBreakdownOverall = useAppSelector(({ builder }) =>
    checkIsForceBreakdownOverall(builder),
  );
  const handleSwitch = () => {
    dispatch(toggleBreakdownOverall(!overallBreakdown));
  };

  return (
    <KubitTooltip
      noOpenDelay={true}
      {...(isForceBreakdownOverall && !overallBreakdown
        ? {
            content:
              'Overall is required for this report now to support more chart types.' +
              ' Re-execute will automatically toggle overall selection.',
          }
        : breakdownOverallTooltipOption)}
    >
      <BuilderUI.BuilderFieldContainer $isDisabled={isForceBreakdownOverall}>
        <Label $isActive={overallBreakdown}>Overall</Label>
        <SwitchiOS
          isChecked={overallBreakdown}
          onClick={isForceBreakdownOverall ? undefined : handleSwitch}
          isDisabled={isForceBreakdownOverall}
        />
      </BuilderUI.BuilderFieldContainer>
    </KubitTooltip>
  );
};

export default BreakdownOverall;
